import { $axios } from "@/plugins/axios";
import { APIS } from "@/constants/apis";
import { getErrorMessageFromApi } from "@/helpers/apis";

async function getAccountOverview() {
    try {
        const { data: { tickers, actual_holdings } } = await $axios.post(APIS.ACCOUNT.OVERVIEW)
        return { tickers, actual_holdings }
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function getBinanceKeys() {
    try {
        const { data } = await $axios.get(APIS.ACCOUNT.GET_BINANCE_KEYS)
        return data
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function refreshAllBinanceKeys() {
    try {
        const { data } = await $axios.get(APIS.ACCOUNT.REFRESH_ALL_BINANCE_KEYS)
        return data
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function deleteBinanceKeys(id) {
    try {
        await $axios.delete(`${APIS.ACCOUNT.DELETE_BINANCE_KEYS}?binance_id=${id}`)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function addBinanceKeys(form) {
    try {
        return await $axios.post(APIS.ACCOUNT.ADD_BINANCE_KEYS, form)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function tradeAccount() {
    try {
        return await $axios.post(APIS.ACCOUNT.TRADE)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function updateBinanceTradingStatus({ status }) {
    try {
        return await $axios.post(`${APIS.ACCOUNT.UPDATE_BINANCE_TRADING_STATUS}?trading_status=${status}`)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

export {
    getAccountOverview,
    getBinanceKeys,
    addBinanceKeys,
    refreshAllBinanceKeys,
    deleteBinanceKeys,
    tradeAccount,
    updateBinanceTradingStatus
}